/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-09 14:48:14
 * @LastEditors: susj
 * @LastEditTime: 2020-11-18 20:16:23
 */

import { cloneDeep } from 'lodash';
import undoRedoHistory from './History';

const recordHistoryMotationTypes = [
  'editor/elementManager',
  'editor/setElementPosition',
  'editor/setElementCommonStyle',
  'editor/setElementPluginProps',
  // 'editor/setEditingPage',
  'editor/pageManager',
];

const undoRedoPlugin = (store) => {
  let flag = true;
  undoRedoHistory.init(store);
  store.subscribeAction((mutation, state) => {
    const { type } = mutation;
    if (flag && type === 'editor/setEditingElement') {
      undoRedoHistory.addState(cloneDeep(state), mutation);
      flag = false;
    }
    if (!recordHistoryMotationTypes.includes(type)) return;
    undoRedoHistory.addState(cloneDeep(state), mutation);
  });
};

export default undoRedoPlugin;
